import { ESeriesCategory } from '@reolink-cloud/interface';
import { ISubscribeData } from './types';

/**
 * 判断是否为带图推送套餐
 */
export const checkIsRichPlan = ( subscribe: ISubscribeData ): boolean => {

    return subscribe.plan.series?.category === ESeriesCategory.CLOUD_RICH_NOTIFICATION_PLAN;

};
